import styled from 'styled-components'

export const ContainerTitleText = styled.div`
  h1 {
    margin-bottom: 8px;
  }
  padding: 0 24px;
`
